import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { renderAccordionBorder, renderArrow } from 'utils';
import styles from './Accordion.module.scss';
import { ReactComponent as ArrowDownIcon } from 'assets/images/ArrowDown.svg';
import { ReactComponent as ShadowArrowDownIcon } from 'assets/images/ShadowArrowDown.svg';

const Accordion = ({
  classNames = { content: '' },
  title = 'Accordion',
  toggleDisabled = false,
  noBreak = false,
  color = '#7d411c',
  type = '',
  isOpened: initOpened = false,
  children
}) => {
  const accordionRef = useRef();
  const [isOpened, setIsOpened] = useState(initOpened);
  const [showMoreIcon, setShowMoreIcon] = useState(false);

  useEffect(() => setShowMoreIcon(isOpened && (accordionRef.current?.scrollHeight || 180) > (type === 'event' ? 300 : 180)), [isOpened, type]);

  const handleClickHeader = () => {
    if (toggleDisabled) return;

    setIsOpened(!isOpened);
  };

  return (
    <div className={clsx(styles.accordion, noBreak && styles['accordion--no-break'])}>
      <div
        className={clsx(styles.accordion__header__wrapper, type === 'event' && styles.accordion__header__event__wrapper)}
        style={{ color: color }}
      >
        <div
          className={clsx(styles.accordion__header, type === 'event' && styles.accordion__event__header, !toggleDisabled && styles['accordion__header--clickable'])}
          onClick={handleClickHeader}
        >
          <span dangerouslySetInnerHTML={{ __html: title }} />
          {!toggleDisabled ? (
            <div>
              {renderArrow(color, clsx(styles.triangle, isOpened && styles['triangle--up']))}
            </div>
          ) : null}
        </div>
      </div>

      {(color && type === 'event') && renderAccordionBorder(color, styles)}

      <div
        className={clsx(
          classNames.content,
          styles.accordion__content,
          type === 'event' && isOpened && styles.accordion__event__content,
          showMoreIcon && styles['accordion__content--opened']
        )}
        ref={accordionRef}
      >
        {children}

        {showMoreIcon && type === 'event' && (
          <div className={styles.accordion__event__content__arrowdown}>
            <ArrowDownIcon />
          </div>
        )}
      </div>

      {showMoreIcon && type !== 'event' && (
        <div className={styles.accordion__content__arrowdown}>
          <ShadowArrowDownIcon />
        </div>
      )}

      {(color && type === 'event' && isOpened) && renderAccordionBorder(color, styles)}
    </div>
  );
};

export default Accordion;